import React, { useContext } from 'react';
import { ThemeContext } from '../../hooks/ThemeContext';
import Watermark from './Watermark';
import ProtectedImage from './ProtectedImage';
import { Images } from 'lucide-react';

const ProductCard = ({ 
  title, 
  description, 
  price, 
  image, 
  category, 
  meta,
  onAddToCart,
  onViewDetails,
  onViewGallery,
  productId
}) => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === 'dark';

  const cardBase = isDark
    ? 'bg-[#0b0b0c] border border-white/6 hover:border-white/12'
    : 'bg-white/95 border border-gray-100 hover:shadow-lg';

  return (
    <div className={`${cardBase} rounded-lg overflow-hidden transition-all group`}>
      {/* Image avec filigrane */}
      <Watermark className={`h-48 ${isDark ? 'bg-[#1a1a1f]' : 'bg-gray-200'}`}>
        {image ? (
          <ProtectedImage
            imagePath={image}
            alt={title}
            className="w-full h-full"
            objectFit="cover"
            showWatermark={true}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <svg className={`w-16 h-16 ${isDark ? 'text-white/10' : 'text-gray-300'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
        )}
        {category && (
          <span className={`absolute top-2 right-2 px-3 py-1 rounded-full text-xs font-medium z-10 ${isDark ? 'bg-rose-500/90 text-white' : 'bg-rose-600 text-white'}`}>
            {category}
          </span>
        )}
      </Watermark>

      {/* Contenu */}
      <div className="p-4">
        <h3 className="text-lg font-semibold mb-2">{title}</h3>
        <p className={`text-sm mb-4 ${isDark ? 'text-white/70' : 'text-gray-600'}`}>
          {description}
        </p>

        {meta && (
          <p className={`text-xs mb-3 ${isDark ? 'text-white/60' : 'text-gray-500'}`}>
            {meta}
          </p>
        )}

        {/* Prix et Actions */}
        <div className="flex items-center justify-between">
          <span className={`text-2xl font-bold ${isDark ? 'text-rose-400' : 'text-rose-600'}`}>
            {price}€
          </span>
          <div className="flex gap-2">
            {onViewGallery && (
              <button
                onClick={() => onViewGallery(productId)}
                className={`p-2 rounded text-sm font-medium ${isDark ? 'bg-blue-500/20 hover:bg-blue-500/30 text-blue-400' : 'bg-blue-100 hover:bg-blue-200 text-blue-700'}`}
                title="Voir la galerie des créations"
              >
                <Images className="w-4 h-4" />
              </button>
            )}
            {onViewDetails && (
              <button
                onClick={onViewDetails}
                className={`px-3 py-2 rounded text-sm font-medium ${isDark ? 'bg-white/10 hover:bg-white/20' : 'bg-gray-100 hover:bg-gray-200'}`}
              >
                Détails
              </button>
            )}
            {onAddToCart && (
              <button
                onClick={onAddToCart}
                className={`px-4 py-2 rounded text-sm font-medium ${isDark ? 'bg-rose-500 hover:bg-rose-600' : 'bg-rose-600 hover:bg-rose-700'} text-white`}
              >
                Ajouter
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
